import { Form, Input } from 'antd'
import React, { useMemo } from 'react'
import { profileScreen } from '../../../../translates'
import { validateName } from '../../../../helper'
import SberIcon from '../../SberIcon'
import TinkoffIcon from '../../TinkoffIcon'

const CountryFormItem = ({
  label = profileScreen.input.registrationAddresscountry.label,
  rules = undefined,
  requiredRule = false,
  messageRule = profileScreen.input.registrationAddresscountry.message,
  size = 'large',
  placeholder = profileScreen.input.registrationAddresscountry.placeholder,
  disabled = false,
  showSberIcon = false,
  showTinkoffIcon = false
}) => {
  const labelParam = useMemo(() => {
    return showSberIcon || showTinkoffIcon
      ? (
        <>
          {label}
          {showSberIcon && <SberIcon style={{ marginLeft: '0.5rem' }} />}
          {showTinkoffIcon && <TinkoffIcon style={{ marginLeft: '0.5rem' }} />}
        </>
      )
      : label
  }, [label, showSberIcon, showTinkoffIcon])

  return (
    <Form.Item
      name={['personalData', 'registrationAddress', profileScreen.input.registrationAddresscountry.name]}
      label={labelParam}
      rules={rules ?? [{ required: requiredRule, message: messageRule, validator: validateName }]}
    >
      <Input
        size={size}
        placeholder={placeholder}
        disabled={disabled}
      />
    </Form.Item>
  )
}
export default CountryFormItem
